<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="inertia-link"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: meta.links.show,
                    },
                    {
                        name: $tc('messages.rubrics', 1),
                        href: null,
                    },
                ]"
            />
        </template>

        <RubricGrade v-model="form.rubric" :ranges="activity.ranges" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import GradeTranslator from '@/classes/GradeTranslator.js';
import RubricGrade from '@/Pages/Teacher/Activities/Rubrics/RubricGrade.vue';

export default {
    components: {
        RubricGrade,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['teacher', 'meta', 'options', 'activity', 'ranges'],
    data() {
        return {
            gradeTranslator: new GradeTranslator(this.ranges),
            form: this.$inertia.form({
                rubric: JSON.parse(JSON.stringify(this.activity.rubric)),
            }),
        };
    },
};
</script>
